import { transformDestinationEvent } from '@eventbrite/event-renderer';
import { deepKeysToSnake } from '@eventbrite/transformation-utils';
import values from 'lodash/values';
import { createSelector } from 'reselect';

const getSuggestedRawEvents = (state: any) => state.suggestions.rawEvents;

export const getEventSuggestions: any = createSelector(
    [getSuggestedRawEvents],
    (rawEvents) => {
        const events = values(rawEvents);
        // FIXME: getSuggestedRawEvents has some internal transforms that make the API data camelCase
        // We revert that transformation to be consistent with the rest of the app
        // We should remove all this transformers in the future, since their overly complex
        return events.map<any>(deepKeysToSnake).map(transformDestinationEvent);
    },
);
